export const appFeed = "EAa";
export default {appFeed};